import {Component, input, output} from '@angular/core';
import {Card} from 'primeng/card';
import {Button} from 'primeng/button';
import {IconLogin} from '@components/icons/icon-login/icon-login';
import {NgOptimizedImage} from '@angular/common';
import {ProgressSpinner} from 'primeng/progressspinner';
import {IconArrowLeftComponent} from '@components/icons/icon-arrow-left/icon-arrow-left.component';

@Component({
  selector: 'app-auth-card',
  imports: [
    Card,
    Button,
    IconLogin,
    NgOptimizedImage,
    ProgressSpinner,
    IconArrowLeftComponent,

  ],
  templateUrl: './auth-card.html',
  styleUrl: './auth-card.css',
  standalone: true
})
export class AuthCard {
  message = input<string>('');
  messageColor = input<string>('#000');
  showLoading = input<boolean>(false);
  showButton = input<boolean>(true);
  buttonIcon = input<'login' | 'arrow-left' | 'none'>('login')
  buttonLabel = input<string>('Acesse sua conta')
  submitted = output<void>();

  onClick() {
    this.submitted.emit();
  }
}
